export const ROUTE_NAMES = {
  FROM_PADMIN: "/from-eadmin/loading/:token",

  Initial: "/",
  Signup: "signup",
  Home: "app",
  Dashboard: "dashboard",
  CEP_Dashboard: "CEP-Admin",
  CompanyDetails: "comapny-details",
  Clients: "clients/comapny-details",
  Payments: "payments",
  Activation: "activation",
  DeleteUser: "delete-user",
  CEP: "candidate-experience-partner",
};
